var React = require('react');

function KeypadAlert (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"matrix(1.001 0 0 1.0263 -85.607 -95.884)","fill":"none","stroke":"currentColor","strokeWidth":"1.4"},[React.createElement("path",{"d":"m96.061 94.768-9.3005 15.501h18.484z","key":0}),React.createElement("path",{"d":"m96.061 100.18v3.8021-0.11699","key":1}),React.createElement("path",{"d":"m96.061 106.41v1.2576","key":2})]));
}

KeypadAlert.defaultProps = {"width":"21","height":"18","version":"1.1","viewBox":"0 0 21 18"};

module.exports = KeypadAlert;

KeypadAlert.default = KeypadAlert;
